var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLinkedin = function SvgIconLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M5.017 4.208a1.246 1.246 0 1 0 0 2.491 1.246 1.246 0 0 0 0-2.491M2.772 5.454a2.246 2.246 0 1 1 4.491 0 2.246 2.246 0 0 1-4.491 0m12.72 3.991a4.737 4.737 0 0 0-4.737 4.737v5.61h2.491v-5.61a2.246 2.246 0 1 1 4.492 0v5.61h2.49v-5.61a4.737 4.737 0 0 0-4.736-4.737m-4.057.68a5.737 5.737 0 0 1 9.794 4.057v6.11a.5.5 0 0 1-.5.5h-3.491a.5.5 0 0 1-.5-.5v-6.11a1.246 1.246 0 0 0-2.492 0v6.11a.5.5 0 0 1-.5.5h-3.491a.5.5 0 0 1-.5-.5v-6.11c0-1.521.604-2.98 1.68-4.056M2.77 9.819a.5.5 0 0 1 .5-.5h3.492a.5.5 0 0 1 .5.5v10.474a.5.5 0 0 1-.5.5H3.27a.5.5 0 0 1-.5-.5zm1 .5v9.474h2.492v-9.474z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLinkedin;